/* eslint-disable */
import styles from './index.module.scss'
import { Link } from 'react-router-dom'
import { useContext } from 'react'
import { BreadcrumbArrow } from '../../../icons'
import { PageContext } from '../../../context/PageContextProvider'

const PageHeader = ({ crumb, link, title, text }) => {
  const { language } = useContext(PageContext)
  const home = {
    AZ: 'Ana Səhifə',
    ENG: 'Home',
    RU: 'Главная страница',
  }
  return (
    <div className={styles.container}>
      <div>
        <div className={styles.breadcrumb}>
          <Link to={'/'}>{home[language]}</Link>
          <BreadcrumbArrow />
          <Link to={link}>{crumb}</Link>
        </div>
        <h1>{title}</h1>
        {text && (
          <p
            dangerouslySetInnerHTML={{
              __html: text,
            }}
          />
        )}
      </div>
    </div>
  )
}
export default PageHeader
